import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class WarehouseLocalizationCreateRequest {
  @jsonMember(String)
  public label!: string;

  public constructor(label: string) {
    this.label = label;
  }
}
